import { CurrencyPipe, DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { getConnection } from "src/app/core/services/functions.service";

@Injectable({
    providedIn: 'root'
})

export class UtilsService {

    datePipe: DatePipe;
    currentPipe: CurrencyPipe;

    constructor() {
        this.datePipe = new DatePipe('en-US')
        this.currentPipe = new CurrencyPipe('en-US');
    }

    formatArrayString(value: string): string {
        return value.replace(/,/g, ' - ');
    }

    formatCurrency(value: number): string {
        return String(this.currentPipe.transform(value, undefined, ""));
    }

    formatDate(date: string | undefined, format: string, timezone: string = '-0000'): string | null {
        return this.datePipe.transform(date, format, timezone);
    }
}